import React from 'react';
import { useSubscription } from './queries';
import { isCancelled, isPastDue } from 'utils/subscriptionUtils';

/**
 * Custom hook to determine if a subscription is active
 * @returns {boolean} True if there's an active subscription, false otherwise
 */
export function useIsSubscriptionActive() {
  const { data: subscription } = useSubscription();

  const isSubscriptionActive = React.useMemo(() => {
    if (!subscription) {
      return false;
    }
    
    // Check if subscription is active (not cancelled and not past due)
    return !isCancelled(subscription) && !isPastDue(subscription);
  }, [subscription]);

  return isSubscriptionActive;
}